<ng-container *transloco="let t">
  <div class="flex flex-col w-full">
    <div class="flex flex-row items-center w-full">
      @if (browser?.inLineWithCaption) {
        <mat-label class="mr-2 mb-4 font-medium">
          {{ caption }} @if (required && !localeStringIsEmpty()) {
          <span>*</span>
        }
      </mat-label>
    }
    <div class="flex flex-col w-full">
      @if (!compact) {
        <div class="flex flex-row justify-end -mb-4 mt-2">
          @for (language of availableLocales; track language) {
            <button class="mx-2 text-sm" mat-raised-button [ngClass]="locale === language.id ? 'bg-gray-200' : ''" (click)="locale = language.id">
              <mat-icon class="icon-size-5 mr-2" [svgIcon]="control.value && control.value[language.id] ? 'heroicons_solid:star' : 'heroicons_outline:star'"></mat-icon>
              @if (!useFlags) {
                <span>{{ language.label }}</span>
              }
              @if (useFlags) {
                <ng-container *ngTemplateOutlet="flagImage; context: {$implicit: language.id}"></ng-container>
              }
            </button>
          }
        </div>
      }

      @switch (type) {
        @case ('LANGUAGETEXT') {
          <mat-form-field class="w-full" [class.invalid]="control.errors?.required && !control.disabled && (control.touched || controlsAreTouched())">
            @if (!browser?.inLineWithCaption) {
              <mat-label>
                {{ caption }} @if (required && !localeStringIsEmpty()) {
                <span>*</span>
              }
            </mat-label>
          }
          <input [ngClass]="{'text-left': !browser || browser?.alignment === 'LEFT', 'text-center': browser?.alignment === 'CENTER', 'text-right': browser?.alignment === 'RIGHT'}"
            matInput [formControl]="localeControls.get(locale)" [placeholder]="placeholder" autocomplete="off" [required]="required && localeStringIsEmpty()">
            @if (compact) {
              <mat-select matPrefix [value]="locale" (selectionChange)="localeChange($event)">
                @if (useFlags) {
                  <mat-select-trigger>
                    <ng-container *ngTemplateOutlet="flagImage; context: {$implicit: locale}"></ng-container>
                  </mat-select-trigger>
                }
                @for (language of availableLocales; track language) {
                  <mat-option [value]="language.id">
                    @if (!useFlags) {
                      <span>{{ language.id }}</span>
                    }
                    @if (useFlags) {
                      <span class="flex items-center">
                        <ng-container *ngTemplateOutlet="flagImage; context: {$implicit: language.id}"></ng-container>
                      </span>
                    }
                  </mat-option>
                }
              </mat-select>
            }
            @if (!compact) {
              <mat-icon class="icon-size-5" matPrefix [svgIcon]="'mat_outline:translate'"></mat-icon>
            }
          </mat-form-field>
        }
        @case ('LANGUAGETEXTAREA') {
          <mat-form-field class="w-full" [class.invalid]="control.errors?.required && !control.disabled && (control.touched || controlsAreTouched())">
            @if (!browser?.inLineWithCaption) {
              <mat-label>
                {{ caption }} @if (required && !localeStringIsEmpty()) {
                <span>*</span>
              }
            </mat-label>
          }
          <textarea [ngClass]="{'text-left': !browser || browser?.alignment === 'LEFT', 'text-center': browser?.alignment === 'CENTER', 'text-right': browser?.alignment === 'RIGHT'}"
          matInput [formControl]="localeControls.get(locale)" [placeholder]="placeholder" autocomplete="off" [required]="required && localeStringIsEmpty()"></textarea>
          @if (compact) {
            <mat-select matPrefix [value]="locale" (selectionChange)="localeChange($event)">
              @if (useFlags) {
                <mat-select-trigger>
                  <ng-container *ngTemplateOutlet="flagImage; context: {$implicit: locale}"></ng-container>
                </mat-select-trigger>
              }
              @for (language of availableLocales; track language) {
                <mat-option [value]="language.id">
                  @if (!useFlags) {
                    <span>{{ language.id }}</span>
                  }
                  @if (useFlags) {
                    <span class="flex items-center">
                      <ng-container *ngTemplateOutlet="flagImage; context: {$implicit: language.id}"></ng-container>
                    </span>
                  }
                </mat-option>
              }
            </mat-select>
          }
          @if (!compact) {
            <mat-icon class="icon-size-5" matPrefix [svgIcon]="'mat_outline:translate'"></mat-icon>
          }
        </mat-form-field>
      }
    }
  </div>
</div>
@if (hint) {
  <mat-hint>{{ hint }}</mat-hint>
}
@if (!localeControls.get(locale).disabled && localeControls.get(locale).errors && localeControls.get(locale).touched) {
  @if (localeControls.get(locale).errors.minlength) {
    <mat-error>
      {{ t('errorMinLengthField', { requiredLength: localeControls.get(locale).errors.minlength.requiredLength }) }}
    </mat-error>
  }
  @if (localeControls.get(locale).errors.maxlength) {
    <mat-error>
      {{ t('errorMaxLengthField', { requiredLength: localeControls.get(locale).errors.maxlength.requiredLength }) }}
    </mat-error>
  }
}
@if (!control.disabled && (control.touched || controlsAreTouched())) {
  @if (control.errors?.required) {
    <mat-error>
      {{ t('errorLocaleTextRequired') }}
    </mat-error>
  }
}
</div>
</ng-container>

<!-- Flag image template -->
<ng-template let-lang #flagImage>
  <span class="relative w-6 shadow rounded-sm overflow-hidden">
    <span class="absolute inset-0 ring-1 ring-inset ring-black ring-opacity-10"></span>
    <img class="w-full" [src]="'assets/images/flags/' + lang + '.svg'" [alt]="'Flag image for ' + lang">
  </span>
</ng-template>